import React, { useContext } from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { styled } from '@mui/material/styles';
import { NotificationContext } from '../../context/NotificationContext';
import { useTranslation } from 'react-i18next';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '@keyframes pulse': {
    '0%': {
      boxShadow: `0 0 0 0 ${theme.palette.error.main}55`,
    },
    '70%': {
      boxShadow: `0 0 0 8px ${theme.palette.error.main}00`,
    },
    '100%': {
      boxShadow: `0 0 0 0 ${theme.palette.error.main}00`,
    },
  },
  '& .MuiBadge-badge': {
    right: -3,
    top: 0,
    padding: '0 4px',
  },
  '& .MuiBadge-badge.pulse': {
    animation: 'pulse 1.2s infinite',
  },
}));

const NotificationBell = ({ onClick, disableTooltip = false }) => {
  const { unreadCount, loading } = useContext(NotificationContext);
  const { t } = useTranslation('notifications');



  const iconButton = (
    <IconButton
      aria-label={t('panel.title')}
      color="inherit"
      onClick={onClick}
      disabled={loading}
    >
      <StyledBadge
        badgeContent={unreadCount}
        color="error"
        classes={{ badge: unreadCount > 0 ? 'pulse' : '' }}
      >
        <NotificationsIcon sx={{ color: '#d1d1d1' }} />
      </StyledBadge>
    </IconButton>
  );

  if (disableTooltip) {
    return iconButton;
  }

  return (
    <Tooltip title={t('panel.title')}>
      {iconButton}
    </Tooltip>
  );
};

export default NotificationBell;
